import { type SectionConfig } from '@/utils/get-matched-section'

/**
 * "My Atlas" route config — one entry per page.
 *
 * Registering these gives each surface the breadcrumbs and page title every
 * other app surface already had. Before the app existed, Inbox and Profile
 * rendered under an empty section config (shell padding, no breadcrumb trail,
 * title inferred from the URL), and Preferences / Notifications / Alert
 * subscriptions weren't routes at all — they were `?tab=` values on Profile.
 */
export const sectionConfig: SectionConfig = {
  '/me/inbox': {
    title: 'Inbox',
    description: 'Your notifications and alerts'
  },
  '/me/profile': {
    title: 'Profile',
    description: 'Your name, contact details, and sign-in'
  },
  '/me/preferences': {
    title: 'Preferences',
    description: 'Your defaults, interface state, and table settings'
  },
  '/me/notifications': {
    title: 'Notifications',
    description: 'Which notifications reach you, and how'
  },
  '/me/alerts': {
    title: 'Alert subscriptions',
    description: 'The alerts you subscribe to and their thresholds'
  }
}
